/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ScreenHeaderAddressQueryVariables = Exact<{
  addressId: string | number;
}>;

export type ScreenHeaderAddressQuery = {
  readonly address: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly name: string | null;
  } | null;
};

export type ScreenHeaderRestaurantQueryVariables = Exact<{
  id: string | number;
}>;

export type ScreenHeaderRestaurantQuery = {
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly name: string;
    readonly isOutpost: boolean;
  } | null;
};

export const ScreenHeaderAddressDocument = gql`
  query ScreenHeaderAddress($addressId: ID!) {
    address(addressId: $addressId) {
      __typename
      id
      latitude
      longitude
      name
    }
  }
`;

export function useScreenHeaderAddressQuery(
  options: Omit<Urql.UseQueryArgs<ScreenHeaderAddressQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ScreenHeaderAddressQuery, ScreenHeaderAddressQueryVariables>({
    query: ScreenHeaderAddressDocument,
    ...options,
  });
}
export const ScreenHeaderRestaurantDocument = gql`
  query ScreenHeaderRestaurant($id: ID!) {
    restaurant(id: $id) {
      __typename
      id
      latitude
      longitude
      name
      isOutpost
    }
  }
`;

export function useScreenHeaderRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<ScreenHeaderRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ScreenHeaderRestaurantQuery, ScreenHeaderRestaurantQueryVariables>({
    query: ScreenHeaderRestaurantDocument,
    ...options,
  });
}
